import { useContext, useEffect, useRef, } from 'react'
import { toast } from 'react-toastify';
import { Button, Input, Spinner } from "@material-tailwind/react";
import { add_surprise_me, update_surprise_me } from '../../Controller/actions';
import { NewContext } from '../../Context/NewContext';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

export const SurpriseMeModel = () => {
    const { isModalLoading, setFormData, setDeleteUpdateTag, deleteUpdateYes, handleFileInput, handleChange, setIsModalLoading, handleClose, formData, open, addEditDeleteTag } = useContext(NewContext);
    const surpriseMeJson = useRef(null);

    useEffect(() => {
        if (addEditDeleteTag === `add`) setFormData({ ...formData, isActive: true })
    }, [addEditDeleteTag, deleteUpdateYes]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        let createUpdatePrompt;
        setIsModalLoading(true);

        const obj = {
            ...formData,
            surpriseMeJson: formData?.surpriseMeJson,
            isActive: formData?.isActive ? true : false,
        }

        if (addEditDeleteTag === `update`) {
            const payload = {
                prompt: formData?.prompt.trim(),
            }
            createUpdatePrompt = await update_surprise_me(payload, formData?._id)
        } else {
            createUpdatePrompt = await add_surprise_me(obj)
        }

        setIsModalLoading(false);
        if (createUpdatePrompt) {
            const { message, status } = createUpdatePrompt;
            if (status) {
                toast.success(message);
                handleClose();
                setDeleteUpdateTag(deleteUpdateYes);
            } else {
                toast.error(message);
            };
        }
    }

    return (
        <>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="responsive-dialog-title"
                sx={{
                    "& .MuiDialog-container": {
                        "& .MuiPaper-root": {
                            width: "100%",
                            maxWidth: "490px",
                            borderRadius: "12px"
                        },
                    },
                }}
            >
                <DialogTitle id="responsive-dialog-title" className='p-0 mb-[30px] text-[#1E1627]'>
                    {
                        addEditDeleteTag === 'view' ? 'Details View' : addEditDeleteTag === 'update' ? `Edit Prompt For Surprise Me` : `Add Prompt For Surprise Me`
                    }

                </DialogTitle>

                <DialogContent>
                    <div>
                        {
                            <form onSubmit={handleSubmit}>
                                <div>
                                    <div className='w-auto'>
                                        <div className="col-span-6 sm:col-span-6 pt-3">
                                            {addEditDeleteTag === 'update' ?
                                                <div className="mt-1.5 relative">
                                                    {/* <label htmlFor="prompt" className="block text-sm font-medium leading-6 text-gray-900"> <p>Update Prompt:<sup className='text-red-800'>*</sup></p> </label> */}
                                                    <Input
                                                        id='prompt'
                                                        placeholder='Enter prompt'
                                                        name='prompt'
                                                        onChange={handleChange}
                                                        minLength={1}
                                                        type='String'
                                                        min={1}
                                                        value={formData?.prompt || ''}
                                                        autoComplete='off'
                                                    />
                                                </div>
                                                :
                                                <div className="mt-1.5 relative">
                                                    <input id='surpriseMeJson' ref={surpriseMeJson} type='file' accept={/\.(json)$/} name='surpriseMeJson' placeholder='Add Prompt' value={formData?.prompt} onChange={e => handleFileInput(e)} className='w-full border px-3 py-1.5 rounded-[7px] text-sm border-blue-gray-200 focus:border-blue-500' required />
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </div>

                                <div className='flex justify-end mt-5'>
                                    <Button
                                        onClick={handleClose}
                                        className="mr-2.5 px-5 py-2.5 bg-white shadow-none text-[#1E3354] font-medium border border-[#75869F] hover:shadow-none capitalize text-base"
                                    >
                                        <span>Cancel</span>
                                    </Button>
                                    <Button
                                        disabled={isModalLoading}
                                        className="flex items-center mr-1 px-5 py-2.5 bg-[#0047FF] shadow-none text-white font-medium border border-[#0047FF] hover:shadow-none capitalize text-base"
                                        type='submit'
                                    >
                                        {isModalLoading && <Spinner className="h-4 w-4" />}
                                        <span className={isModalLoading ? 'ml-4' : ''}>{addEditDeleteTag === `update` ? `Update` : `Add`}</span>
                                    </Button>
                                </div>
                            </form>
                        }
                    </div>
                </DialogContent>
            </Dialog >
        </>
    )
}

export default SurpriseMeModel
